import type { Theme } from '@mui/material';

import { useState, useEffect } from 'react';

import {
  Box,
  Checkbox,
  FormGroup,
  Typography,
  useMediaQuery,
  FormControlLabel,
} from '@mui/material';

import { Scrollbar } from 'src/components/scrollbar';

export const DaysFilter = (props: { filters: any; setFilters: React.Dispatch<any> }) => {
  const downSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const weekDays = [
    { value: 0, label: 'Pazartesi' },
    { value: 1, label: 'Salı' },
    { value: 2, label: 'Çarşamba' },
    { value: 3, label: 'Perşembe' },
    { value: 4, label: 'Cuma' },
    { value: 5, label: 'Cumartesi' },
    { value: 6, label: 'Pazar' },
  ];

  const [selectedDays, setSelectedDays] = useState<number[]>(props.filters.schedule.days || []);

  useEffect(() => {
    setSelectedDays(props.filters.schedule.days || []);
  }, [props.filters.schedule.days]);

  const handleDayChange = (dayValue: number) => {
    const newSelectedDays = selectedDays.includes(dayValue)
      ? selectedDays.filter((d) => d !== dayValue)
      : [...selectedDays, dayValue];
    setSelectedDays(newSelectedDays);
    props.setFilters((prevFilters: { schedule: any; }) => ({
      ...prevFilters,
      schedule: {
        ...prevFilters.schedule,
        days: newSelectedDays.length > 0 ? newSelectedDays : null,
      },
    }));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
        Gün
      </Typography>

      <Scrollbar sx={{ maxHeight: 164 }}>
        <FormGroup>
          {weekDays.map((day) => (
            <FormControlLabel
              key={day.value}
              control={
                <Checkbox
                  checked={selectedDays.includes(day.value)}
                  onChange={() => handleDayChange(day.value)}
                  sx={{ py: 0.25 }}
                />
              }
              label={day.label}
            />
          ))}
        </FormGroup>
      </Scrollbar>
    </Box>
  );
};
